import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import {Col, FormGroup, Input, Label, Row} from 'reactstrap';
import _ from 'lodash';
import PropTypes from 'prop-types';
import {Validacao} from "../../../comum/components/Validacao";
import Select from "react-select";
import {createSelectOptions, getByAtribute} from "../../../../utils/formatar";
import NumberFormat from "react-number-format";
import DatePicker from "react-datepicker";
import moment from "moment";

@inject("store")
@observer
export class DetalhamentoAlterarDataInicio extends Component {

    static propTypes = {
        controller: PropTypes.object
    };

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const { controller } = this.props;
        const momentDataInicio = _.get(controller, "solicitacao.momentDataInicio");

        if (controller.novaDataInicialEditavel && momentDataInicio && momentDataInicio.isBefore(moment().startOf('day'))) {
            // Força a marcação do checkbox se a data de início for anterior a hoje.
            controller.forcarAlteracaoDataInicio();
        }
    }

    render() {
        const informarDataInicioDiferente = this.props.controller.getInformarDataInicioDiferente;
        const novaDataInicialEditavel = this.props.controller.novaDataInicialEditavel;
        const momentNovaDataInicio = this.props.controller.getMomentNovaDataInicio;
        const momentDataInicio = _.get(this.props.controller, "solicitacao.momentDataInicio");
        const momentDataTermino = _.get(this.props.controller, "solicitacao.momentDataTermino");
        //momentDataTermino.add(this.props.controller.quantidadeDias-1, 'days');//_.get(this.props.controller, "solicitacao.momentDataTermino");
        const totalDiasContratoAtualizado = this.props.controller.totalDiasContratoAtualizado;
        const exibeRazaoAtraso = this.props.controller.exibeRazaoAtraso;
        const nomeRazaoAtraso = _.get(this.props.controller, "confirmarAlocacaoETT.razaoAtraso");
        const dataInicioAlterada =  this.props.controller.getDataInicioAlterada;
        const desabilitarValidacao = _.get(this.props, "desabilitarValidacao", false);
        const admLogadoETarefaEttValidacaoGestor = this.props.controller.isAdmEmConfirmacaoContratacaoGestor;
        
        return (
            <div>
                {novaDataInicialEditavel ?  (
                <FormGroup check className="checkbox-title">
                    <Label check>
                        <Input type="checkbox"
                               checked={this.props.controller.confirmarAlocacaoETT.informarDataInicioDiferente}
                               onChange={() => this.props.controller.toggleInformarDataInicioDiferente()}
                        />{' '}
                         <span>Alterar a data de início do contrato</span>
                    </Label>
                </FormGroup>
                ) :  dataInicioAlterada !== null ? <h4>Data de início do contrato alterada</h4> : ""}
                {((novaDataInicialEditavel && this.props.controller.confirmarAlocacaoETT.informarDataInicioDiferente) || dataInicioAlterada !== null) &&
                <div>
                    <Row>
                        <Col xs={12} md={6} lg={4}>
                            <FormGroup>
                                <Label>Nova data de início</Label>
                                <DatePicker
                                    ref="dataInicio"
                                    onClickOutside={()=>{this.refs.dataInicio.cancelFocusInput(); this.refs.dataInicio.setOpen(false);}}
                                    locale={"pt_BR"}
                                    className="form-control"
                                    dateFormat="DD/MM/YYYY"
                                    selectsStart
                                    selected={momentNovaDataInicio}
                                    startDate={moment()}
                                    minDate={moment()}
                                    maxDate={momentDataTermino}
                                    endDate={momentDataTermino}
                                    onChange={(value) => this.props.controller.setNovaDataInicio(value)}
                                    disabled={!novaDataInicialEditavel}
                                    onBlur={(e) => this.props.controller.setNovaDataInicioCheck(e.target.value)}
                                />
                                {!desabilitarValidacao && 
                                    (admLogadoETarefaEttValidacaoGestor 
                                    ? (<Validacao id="dataInicio" valor={this.props.controller.dataInicioValidacao} 
                                        tipo={["isRequired", "isDate"]} />) 
                                    : (<Validacao id="dataInicio" valor={this.props.controller.dataInicioValidacao}
                                           tipo={["isRequired", "isDate","compararDataAnterior", moment().format("DD/MM/YYYY")]}/>)
                                    )
                                }
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={6} lg={4}>
                            <FormGroup>
                                <Label>Total de dias do contrato atualizado</Label>
                                <Input type="text" value={totalDiasContratoAtualizado} readOnly/>
                            </FormGroup>
                        </Col>
                    </Row>
                    {(exibeRazaoAtraso && dataInicioAlterada !== null) &&
                    <Row>
                        <Col xs={12} md={6} lg={4}>
                            <FormGroup>
                                <Label>Razão de alteração de início</Label>
                                <Input type="text" value={nomeRazaoAtraso}
                                       readOnly/>
                            </FormGroup>
                        </Col>
                    </Row>
                    }
                </div>
                }
            </div>
        )
    }
}